import { HStack, Box } from "@chakra-ui/react"

export default function Footer() {
    return (
        <Box as="footer" p="4" position="fixed" bottom="0" width="100%">
            <HStack justify="center">
            </HStack>
        </Box>
    )
}